import React from "react";

import { NavItem } from "@common/components/Navigation/Navigation";
import identifiers from "@common/util/identifiers.json";
import { resolveCurrentDomainRoute } from "@common/util/resolveCurrentDomainRoute";
import { useAppSelectionContext } from "@main/context/App/AppSelectionContext";
import { getModuleInfo } from "@main/layouts/components/PageNavigation/moduleInfo";
import { RoutePaths } from "@main/router/config/routePaths";
import { useCurrentPathRouteConfig } from "@main/router/util/useCurrentPathRouteConfig";
import { useLocation } from "react-router-dom";

import PageInfoPopover from "./PageInfoPopover";

export default function PageName() {
  const location = useLocation();
  const { pageName, moduleRoot } = useCurrentPathRouteConfig();
  const { selectedApp } = useAppSelectionContext();

  const info = moduleRoot ? getModuleInfo(selectedApp?.platform?.name)[moduleRoot] : undefined;

  return (
    <NavItem withClick={false}>
      <span data-testid={getTestIdForTitle(resolveCurrentDomainRoute(location.pathname))}>{pageName}</span>
      {info && <PageInfoPopover info={info} />}
    </NavItem>
  );
}

const getTestIdForTitle = (
  route?: RoutePaths.USER_FEEDBACK | RoutePaths.CRASH_REPORTS | RoutePaths.USERS | RoutePaths.RELEASES,
) => {
  switch (route) {
    case RoutePaths.USERS:
      return identifiers["users.header"];
    case RoutePaths.CRASH_REPORTS:
      return identifiers["crash.reports.header"];
    case RoutePaths.RELEASES:
      return "";
    default:
      return identifiers["user.feedback.header"];
  }
};
